import CreateBrandModal from './CreateBrandModal.Container';

export default CreateBrandModal;
